import React from 'react';
import './PetAnimations.css';

export default function RabbitSvg({ size = 120, color, className = '' }) {
  const bodyColor = color || '#C8B090';
  const lightColor = '#F5EDE0';
  const darkColor = '#8B7560';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      className={`pet-svg pet-idle ${className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Tail puff */}
      <circle cx="82" cy="82" r="8" fill={lightColor} />
      {/* Body - round */}
      <ellipse cx="60" cy="78" rx="26" ry="24" fill={bodyColor} />
      {/* Belly */}
      <ellipse cx="60" cy="84" rx="16" ry="14" fill={lightColor} />
      {/* Back legs - big */}
      <ellipse cx="40" cy="96" rx="12" ry="7" fill={bodyColor} />
      <ellipse cx="80" cy="96" rx="12" ry="7" fill={bodyColor} />
      {/* Front paws */}
      <ellipse cx="48" cy="98" rx="5" ry="3.5" fill={darkColor} />
      <ellipse cx="72" cy="98" rx="5" ry="3.5" fill={darkColor} />
      {/* Head */}
      <circle cx="60" cy="46" r="20" fill={bodyColor} />
      {/* Cheeks */}
      <circle cx="48" cy="52" r="6" fill={lightColor} opacity="0.7" />
      <circle cx="72" cy="52" r="6" fill={lightColor} opacity="0.7" />
      {/* Left ear - long */}
      <ellipse cx="46" cy="18" rx="7" ry="18" fill={bodyColor} />
      <ellipse cx="46" cy="18" rx="4" ry="14" fill="#E8B0B0" />
      {/* Right ear - slightly droopy */}
      <ellipse cx="74" cy="20" rx="7" ry="17" fill={bodyColor} transform="rotate(8 74 20)" />
      <ellipse cx="74" cy="20" rx="4" ry="13" fill="#E8B0B0" transform="rotate(8 74 20)" />
      {/* Eyes */}
      <circle cx="52" cy="43" r="4.5" fill="white" />
      <circle cx="68" cy="43" r="4.5" fill="white" />
      <circle cx="53" cy="43.5" r="3" fill="#5C2E1A" />
      <circle cx="69" cy="43.5" r="3" fill="#5C2E1A" />
      <circle cx="54" cy="42" r="1.2" fill="white" />
      <circle cx="70" cy="42" r="1.2" fill="white" />
      {/* Nose */}
      <ellipse cx="60" cy="50" rx="2.5" ry="2" fill="#E8A0A0" />
      {/* Mouth */}
      <path d="M60 52V54" stroke={darkColor} strokeWidth="1" strokeLinecap="round" />
      <path d="M57 54C57 54 58.5 56 60 56C61.5 56 63 54 63 54" stroke={darkColor} strokeWidth="0.8" strokeLinecap="round" fill="none" />
      {/* Whiskers */}
      <line x1="38" y1="50" x2="48" y2="51" stroke={darkColor} strokeWidth="0.5" />
      <line x1="38" y1="53" x2="48" y2="53" stroke={darkColor} strokeWidth="0.5" />
      <line x1="82" y1="50" x2="72" y2="51" stroke={darkColor} strokeWidth="0.5" />
      <line x1="82" y1="53" x2="72" y2="53" stroke={darkColor} strokeWidth="0.5" />
    </svg>
  );
}
